<template>
  <div>
    <input
        type="checkbox"
        :id="`checkbox-${uuid}`"
        :name="`checkbox-${uuid}`"
        hidden
        :checked="isChecked"
        ref="checkbox"
        @click="selectCompany"
    />
    <label class="custom-checkbox" :for="`checkbox-${uuid}`">
      <svg
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
        ></path>
      </svg>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    uuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
      );
    },
  },
  watch: {
    checked(newVal, oldVal) {
      this.isChecked = newVal;
    },
  },
  data() {
    return {
      isChecked: false,
      ChildrenChecked: [],
    };
  },
  mounted() {
    if (this.checked) {
      this.isChecked = this.checked;
    }
    this.$eventBus.$on('companyChecked', (groupName, id) => {
      if(groupName == this.value){
        this.ChildrenChecked.push(id);
        if (!this.isChecked){
          this.isChecked = true;
        }
      }
    })
    this.$eventBus.$on('companyUnChecked', (groupName, id) => {
      if(groupName == this.value){
          this.ChildrenChecked = this.ChildrenChecked.filter(item => item != id);
          if (this.ChildrenChecked.length == 0 && this.isChecked){
            this.isChecked = false;
          }
      }
    })
  },
  methods: {
    toggleAll() {
      if (this.checked) {
        this.$emit("deselectAll");
      } else {
        this.$emit("selectAll");
      }
    },
    selectCompany() {
      if (this.checkAll) {
        this.toggleAll();
      } else {
        this.$emit("toggleCompany", this.value);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.custom-checkbox {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: white;
  background-color: #fff;
  border-color: #bdb6b6d7;
  border-width: 1px;
  border-style: solid !important;
  border-radius: 0.2rem;
  cursor: pointer;
  position: relative;

  svg {
    width: 14px;
  }
}

[type="checkbox"]:checked + .custom-checkbox {
  background-color: #2563eb;
}
</style>